import Axios from '../lib/axios';

const LoginCheck = () => {
  return Axios.get(process.env.REACT_APP_SERVER_ROOT + '/login_check');
};

const LogOut = () => {
  return Axios.post(process.env.REACT_APP_SERVER_ROOT + '/logout');
};

const AuthService = {
  LoginCheck,
  LogOut,
};

export default AuthService;
